const language = (document.getElementById('language') as HTMLSelectElement);

if (language) {
    language.addEventListener('change', () => window.location.replace(language.value));
}